import { SplitFactoryProvider, useSplitTreatments } from '@splitsoftware/splitio-react';
import { type PropsWithChildren } from 'react';

import { Loading } from '@verantos-dev/shared-components';

import { useAuth } from '../../../auth';

const bypassSplit = import.meta.env.VITE_BYPASS_SPLIT === 'true';
const authorizationKey = import.meta.env.VITE_SPLIT_CLIENT_SDK_API_KEY;

// Using the SplitFactoryProvider component, MyApp component and all its descendants have access to the SDK functionality.
// https://help.split.io/hc/en-us/articles/360038825091-React-SDK
export const SplitFFProvider = ({ children }: PropsWithChildren) => {
  const {
    user: { email },
  } = useAuth();
  // Allow '+' in user keys so addresses like 'user+tag@domain.com' are preserved for targeting
  const sanitizedEmail = email?.replace(/[^a-zA-Z0-9 .@_+-]/g, '.');
  // TODO: look into attributes for further filtering
  // const sanitizedFirstName = firstName?.replace(/[^a-zA-Z0-9À-ÿ .@_-]/g, '.');
  // const sanitizedLastName = lastName?.replace(/[^a-zA-Z0-9À-ÿ .@_-]/g, '.');

  if (bypassSplit) {
    console.warn(
      'Bypassing SplitFFProvider for local development because VITE_BYPASS_SPLIT is set to true.'
    );
    return children;
  }

  if (!authorizationKey) {
    throw new Error('Client Side ID is missing');
  }

  // Create the config for the SDK factory.
  const sdkConfig: SplitIO.IBrowserSettings = {
    core: {
      authorizationKey,
      // key represents your internal user id, or the account id that
      // the user belongs to.
      // This could also be a cookie you generate for anonymous users.
      key: sanitizedEmail || 'anonymous',
    },
  };

  return (
    <SplitFactoryProvider config={sdkConfig}>
      <LoadingUntilFFReady>{children}</LoadingUntilFFReady>
    </SplitFactoryProvider>
  );
};

const LoadingUntilFFReady = ({ children }: PropsWithChildren) => {
  const { isReady } = useSplitTreatments({
    flagSets: [''],
  });

  return isReady ? children : <Loading />;
};
